import { Flex, Space, Tag } from 'antd';
import {
  CalendarOutlined,
  EditOutlined,
  EyeOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const RuleRow = ({
  rule,
  pageType,
  t,
  onView,
  onEdit,
  renderCopyButton,
  renderRuleDeleteButton,
}) => (
  <Flex justify="space-between" align="center" style={{ paddingLeft: 40 }}>
    <div>
      <Space size={16} align="center" className="mb-2">
        <span className="font-medium text-base">{rule.rule_name}</span>
        <span className="flex items-center gap-1 text-slate-500 text-xs">
          <CalendarOutlined />
          {rule?.rule_start_date
            ? dayjs(rule.rule_start_date).format('YYYY-MM-DD')
            : '-'}
          {' - '}
          {rule?.rule_end_date
            ? dayjs(rule.rule_end_date).format('YYYY-MM-DD')
            : '-'}
        </span>
        {rule?.rule_versions_count ? (
          <span className="flex items-center gap-1 text-slate-500 text-xs">
            <FileTextOutlined />
            {rule.rule_versions_count} version
            {rule.rule_versions_count !== 1 ? 's' : ''}
          </span>
        ) : null}
      </Space>
      <div className="text-xs text-gray-400 font-mono">
        {rule?.rule_applicability?.value}
      </div>
    </div>
    <Space size={20}>
      <Tag color={rule.rule_is_active ? 'green' : 'default'}>
        {rule.rule_is_active ? t('rules.ruleActive') : t('rules.ruleInactive')}
      </Tag>
      {pageType === 'Show' ? (
        <EyeOutlined
          style={{ fontSize: 20 }}
          className="a8-edit-button"
          onClick={() => onView(rule)}
        />
      ) : null}
      {pageType !== 'Show' ? (
        <>
          <EditOutlined
            style={{ fontSize: 20 }}
            className="a8-edit-button"
            onClick={() => onEdit(rule)}
          />
          {renderCopyButton(rule)}
          {renderRuleDeleteButton(rule)}
        </>
      ) : null}
    </Space>
  </Flex>
);

export default RuleRow;
